import LotusMark from './LotusMark.jsx';

export default function SectionHeader({ label, title, body, align = 'left', light = false }) {
  return (
    <header className={`section-header section-header--${align} ${light ? 'section-header--light' : ''}`}>
      {label ? <div className="section-label"><span />{label}<LotusMark /><span /></div> : null}
      <h2>{title}</h2>
      {body ? <p>{body}</p> : null}
    </header>
  );
}
